import AppHeader from './AppHeader';

/**
 * Shared layout for placeholder pages (/messages, /roommates, /settings, ...).
 *
 * Takes an icon + headline + body copy + optional CTA. All have the global
 * AppHeader so users can navigate away without feeling trapped.
 */
const ComingSoonLayout = ({ icon: Icon, headline, body, footnote, testId }) => (
  <div className="min-h-screen bg-background flex flex-col" data-testid={testId}>
    <AppHeader />
    <main className="flex-1 px-5 py-12 sm:py-20">
      <div className="max-w-md mx-auto text-center">
        <div className="mx-auto w-16 h-16 bg-amber-100 rounded-2xl flex items-center justify-center mb-5">
          <Icon className="h-8 w-8 text-amber-600" />
        </div>
        <h1 className="text-2xl sm:text-3xl font-heading font-extrabold text-slate-900 leading-tight">
          {headline}
        </h1>
        <p className="mt-3 text-base text-slate-600 leading-relaxed">{body}</p>
        {footnote && <p className="mt-5 text-xs text-slate-500">{footnote}</p>}
      </div>
    </main>
  </div>
);

export default ComingSoonLayout;
